import { BASE_URL } from "./variables";
import { getAuthHeaders } from "./auth";

const FALLBACK_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjU5NSwiYnVzaW5lc3NJZCI6NzEsIk1lbWJlcklEIjo5MTksInVzZXJuYW1lIjoiYW5rb3RhLmFkbWluIiwiZmlyc3ROYW1lIjoiSm9obiIsImxhc3ROYW1lIjoiRG9lIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.oCgeNmQXN2gsf64gLZ4x70AsUUkY6k9tFZDTf5bGll4';

export const getPayrollTransactionsByServiceOrder = async (patientId, startDate, endDate) => {
  try {
    const headers = getAuthHeaders();
    if (!headers['Authorization']) headers['Authorization'] = `Bearer ${FALLBACK_TOKEN}`;

    const url = `${BASE_URL}/get-payroll-transactions-by-serviceorder?patientId=${patientId}&startDate=${startDate}&endDate=${endDate}`;
    const response = await fetch(url, { headers });

    if (response.status === 404) return { visits: [] };
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    return await response.json();
  } catch (error) {
    console.error('Error fetching payroll transactions:', error);
    return { visits: [] };
  }
};
